// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"53d9a552","89":"b0e8c2e6","339":"47dd8cda","355":"7d9bf37c","388":"ba1195e9","453":"05098716","457":"9d608de4","484":"59be1ae6","488":"893bea09","498":"5fd4a6c7","551":"e7c8e336","815":"6c434ddc","842":"5eb6944e","851":"9b4c4f18"}[chunkId] + ".chunk.js";
};